import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		NvsprdnPrp: null as boolean | null,
		NvszavdPrp: null as boolean | null,
		OpravadokladPrp: null as boolean | null,
		PnvPrp: null as boolean | null,
		PovPrp: null as boolean | null,
		Poznamka: null as string | null,
		SkladpneuPrp: null as boolean | null,
		ZakazkaPrp: null as boolean | null,
		ZlPrp: null as boolean | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
